module.exports = __webpack_public_path__ + "img/core-certificate.f64683df.png";